import React, { useEffect, useRef, useState } from 'react';

const ClapTheCount = () => {
  const [currentNumber, setCurrentNumber] = useState(0);
  const [selectedMultiple, setSelectedMultiple] = useState(null);
  const [feedback, setFeedback] = useState('');
  const [gameStarted, setGameStarted] = useState(false);
  const [isHighlight, setIsHighlight] = useState(false);
  const intervalRef = useRef(null);

  const correctSound = useRef(new Audio('https://actions.google.com/sounds/v1/cartoon/clang_and_wobble.ogg'));
  const wrongSound = useRef(new Audio('https://actions.google.com/sounds/v1/cartoon/wood_plank_flicks.ogg'));

  const startGame = () => {
    if (!selectedMultiple) {
      alert('Please select a number to begin.');
      return;
    }

    setCurrentNumber(0);
    setGameStarted(true);
    setFeedback(`Game Started! Clap when it's a multiple of ${selectedMultiple}`);

    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setCurrentNumber(prev => {
        const next = prev + 1;
        setIsHighlight(next % selectedMultiple === 0);
        return next;
      });
    }, 1000);
  };

  const handleClap = () => {
    if (!gameStarted) {
      alert('Please start the game first!');
      return;
    }

    if (currentNumber % selectedMultiple === 0) {
      setFeedback('✅ Great clap!');
      correctSound.current.currentTime = 0;
      correctSound.current.play();
    } else {
      setFeedback('❌ Oops! Not a multiple!');
      wrongSound.current.currentTime = 0;
      wrongSound.current.play();
    }

    setTimeout(() => setFeedback(''), 1200);
  };

  useEffect(() => {
    return () => clearInterval(intervalRef.current);
  }, []);

  const styles = {
    body: {
      fontFamily: "'Comic Sans MS', cursive",
      textAlign: 'center',
      background: '#f0f8ff',
      color: '#333',
      padding: 'clamp(1rem, 4vw, 2.5rem)',
      minHeight: '100vh',
    },
    h1: {
      fontSize: 'clamp(2rem, 4vw, 3rem)',
      color: '#2e7d32',
    },
    countDisplay: {
      fontSize: 'clamp(3rem, 10vw, 6rem)',
      margin: 'clamp(1rem, 5vw, 2.5rem) 0',
      color: isHighlight ? '#d32f2f' : '#1976d2',
      transform: isHighlight ? 'scale(1.4)' : 'scale(1)',
      transition: 'all 0.3s ease-in-out',
    },
    feedback: {
      fontSize: 'clamp(1rem, 3vw, 1.8rem)',
      height: '2.5rem',
      transition: 'color 0.3s',
    },
    button: {
      fontSize: 'clamp(1rem, 3vw, 1.5rem)',
      padding: 'clamp(0.6rem, 3vw, 1rem) clamp(1rem, 5vw, 2rem)',
      margin: 'clamp(0.5rem, 2vw, 1rem)',
      backgroundColor: '#ff5722',
      color: 'white',
      border: 'none',
      borderRadius: '10px',
      cursor: 'pointer',
    },
    select: {
      fontSize: 'clamp(1rem, 3vw, 1.5rem)',
      padding: 'clamp(0.6rem, 3vw, 1rem) clamp(1rem, 5vw, 2rem)',
      margin: 'clamp(0.5rem, 2vw, 1rem)',
      backgroundColor: '#1976d2',
      color: 'white',
      border: 'none',
      borderRadius: '10px',
      cursor: 'pointer',
    },
  };

  return (
    <div style={styles.body}>
      <h1 style={styles.h1}>👏 Clap the Count!</h1>
      <p>Select a number and clap (press the button) when a <strong>multiple</strong> of it appears!</p>

      <select
        style={styles.select}
        onChange={(e) => setSelectedMultiple(parseInt(e.target.value))}
        defaultValue=""
      >
        <option value="" disabled>Choose a number (1–10)</option>
        {[...Array(10)].map((_, i) => (
          <option key={i + 1} value={i + 1}>{i + 1}</option>
        ))}
      </select>

      <button style={styles.button} onClick={startGame}>▶️ Start Game</button>

      <div style={styles.countDisplay}>{currentNumber}</div>

      <button style={styles.button} onClick={handleClap}>👏 Clap!</button>

      <div
        style={{
          ...styles.feedback,
          color: feedback.includes('✅') ? '#2e7d32' : feedback.includes('❌') ? '#c62828' : '#ff6f00',
        }}
      >
        {feedback}
      </div>
    </div>
  );
};

export default ClapTheCount;
